import React from 'react';
import { Sparkles, Search, Zap, Brain, TrendingUp, ExternalLink } from 'lucide-react';
import './GrokAI.css';

const GrokAI = () => {
  const handleOpenGrok = () => {
    window.open('https://grok.x.ai', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="grok-container fade-in" data-testid="grok-view">
      <div className="container">
        <div className="grok-hero">
          <div className="grok-icon-wrapper">
            <Sparkles size={64} className="grok-main-icon" />
          </div>

          <h1 className="grok-title">
            Grok AI
            <span className="grok-subtitle">Inteligencia Artificial para Búsqueda de Noticias</span>
          </h1>

          <p className="grok-description">
            Potencia tu monitoreo de medios con Grok, la IA avanzada que te ayuda a encontrar,
            analizar y comprender noticias y publicaciones relevantes en tiempo real.
          </p>

          <button 
            className="btn-grok-main"
            onClick={handleOpenGrok}
            data-testid="open-grok-btn"
          >
            <Sparkles size={20} />
            Abrir Grok AI
            <ExternalLink size={18} />
          </button>
        </div>

        <div className="grok-features">
          <div className="feature-grok">
            <div className="feature-grok-icon">
              <Search size={32} />
            </div>
            <h3>Búsqueda Inteligente</h3>
            <p>
              Encuentra noticias y publicaciones relevantes con consultas en lenguaje natural.
              Grok comprende el contexto y te proporciona resultados precisos.
            </p>
          </div>

          <div className="feature-grok">
            <div className="feature-grok-icon">
              <Brain size={32} />
            </div>
            <h3>Análisis Profundo</h3>
            <p>
              Analiza el contenido de publicaciones, detecta patrones y obtiene insights
              valiosos sobre temas de interés en corrupción y transparencia.
            </p>
          </div>

          <div className="feature-grok">
            <div className="feature-grok-icon">
              <TrendingUp size={32} />
            </div>
            <h3>Tendencias en Tiempo Real</h3>
            <p>
              Identifica tendencias emergentes, temas virales y patrones de conversación
              relacionados con instituciones públicas.
            </p>
          </div>

          <div className="feature-grok">
            <div className="feature-grok-icon">
              <Zap size={32} />
            </div>
            <h3>Respuestas Instantáneas</h3>
            <p>
              Obtiene respuestas rápidas y precisas sobre cualquier tema, persona o
              institución que necesites monitorear.
            </p>
          </div>
        </div>

        <div className="grok-usage">
          <h2 className="usage-title">Cómo usar Grok para Monitoreo de Medios</h2>

          <div className="usage-steps">
            <div className="usage-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h4>Accede a Grok</h4>
                <p>Haz clic en el botón "Abrir Grok AI" para acceder a la plataforma.</p>
              </div>
            </div>

            <div className="usage-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h4>Realiza Consultas Específicas</h4>
                <p>Pregunta sobre instituciones, personas o temas específicos que desees monitorear.</p>
              </div>
            </div>

            <div className="usage-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h4>Analiza los Resultados</h4>
                <p>Revisa las publicaciones y noticias encontradas por Grok con análisis contextual.</p>
              </div>
            </div>

            <div className="usage-step">
              <div className="step-number">4</div>
              <div className="step-content">
                <h4>Registra en el Sistema</h4>
                <p>Copia la información relevante y regístrala en el sistema de Monitoreo de Medios.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="grok-examples">
          <h3 className="examples-title">Ejemplos de Consultas</h3>

          <div className="examples-grid">
            <div className="example-card">
              <div className="example-icon">"¡</div>
              <p>"Busca publicaciones sobre el Ministerio de Educación en los últimos 7 días"</p>
            </div>

            <div className="example-card">
              <div className="example-icon">"¿</div>
              <p>"Analiza la percepción pública sobre la Contraloría General de Cuentas"</p>
            </div>

            <div className="example-card">
              <div className="example-icon">"🔍</div>
              <p>"Encuentra noticias sobre posibles irregularidades en licitaciones públicas"</p>
            </div>

            <div className="example-card">
              <div className="example-icon">"📈</div>
              <p>"¿Cuáles son las tendencias actuales sobre transparencia gubernamental?"</p>
            </div>
          </div>
        </div>

        <div className="grok-cta">
          <div className="cta-content">
            <Sparkles size={40} className="cta-icon" />
            <h3>Comienza a Usar Grok AI Ahora</h3>
            <p>Descubre información relevante con el poder de la inteligencia artificial</p>
            <button 
              className="btn-grok-secondary"
              onClick={handleOpenGrok}
              data-testid="open-grok-cta-btn"
            >
              Abrir Grok AI
              <ExternalLink size={18} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GrokAI;